import { render, staticRenderFns } from "./LinkWideRoundedIcon.vue?vue&type=template&id=24c17a49&scoped=true"
import script from "./LinkWideRoundedIcon.vue?vue&type=script&lang=js"
export * from "./LinkWideRoundedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c17a49",
  null
  
)

export default component.exports